import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import {
  getKey,
  clientMessage,
  removeDataForLogging,
  staticPath,
  equalsIgnoreCase,
  isIphoneDevice,
  scrollInContentWrap,
  cloneObject,
  isMobileDevice
} from '../../utils/common';
import { onChange } from '../../common/actions';
import CONSTANT, { CACHE, GLOBAL_STORE } from '../../utils/constants';
import { EVENT, log } from '../../common/logger';
import { locale as getLocale } from '../../utils/i18n';
import { PAYMODE } from '../../../../common/src/constant';
import { updateOnNewFPO } from '../../controllers/switch-user';
import { globaleStore } from '../../common/cache';
import { processLocalStorage } from '../../common/localStorage';

class LoginComponent extends Component {
  numberRegex = /[^0-9]/g;

  mobileRef = '';

  interval = null;

  otpRef = '';

  constructor(props) {
    super(props);
    this.setInitialState();
    const locale = clientMessage(CONSTANT.LOGIN.toLowerCase(), this.props.cache);
    this.label = locale.label;
    this.error = locale.error;
  }

  setInitialState(resetRememberMe = true) {
    const state = {
      showOtpInput: false,
      invalidMobileNumber: false,
      sendOtpApiMsg: false,
      validateOtpErrMsg: '',
      showMobileInputErr: false,
      otpInput: '',
      isOtpValid: false,
      showOtpInputErr: false,
      mobileNumber: '',
      otp: '',
      monileNumberFocus: false,
      otpFocus: false,
      VerifyOtpMsg: '',
      pwpEnabled: getKey(this.props.cache.getData(CACHE.PAYMENT_OPTIONS, {}), 'pwpEnabled')
    };

    if (resetRememberMe) {
      state.rememberMe = false;
      state.showRememberStrip = false;
    }

    this.setState(state);
  }

  componentDidMount() {
    const _rememberMe =
      this.props.cache.getData('paymentOptions').loginInfo &&
      this.props.cache.getData('paymentOptions').loginInfo.pgAutoLoginEnabled;
    this.setState({ rememberMe: _rememberMe, showRememberStrip: _rememberMe });
    const paymentMode = getKey(this.props, 'selected.paymentMode', null);
    if (equalsIgnoreCase(paymentMode, PAYMODE.LOGIN)) {
      // this.focusOnMobileInput();
      setTimeout(() => {
        this.props.onBtnTextChange(this.label.btnSendOtpText);
      }, 0);
    }
  }

  focusOnMobileInput = () => {
    try {
      log({ eventType: EVENT.MOBILE_NUMBER_FOCUS });
      /* setting timeout since coming from  change number input was not being focused */
      setTimeout(() => {
        !isIphoneDevice() && isMobileDevice() && this.mobileRef && this.mobileRef.focus();
        const loginElement = document.getElementById('checkout-login');
        const loginComponentOffsetTop = getKey(loginElement, 'offsetTop', 0);
        scrollInContentWrap(loginComponentOffsetTop + 16);
      }, 100);
      /* setting timeout scrolling since when keyboard opens the height changes , and it will
      scrolleffectively to the paymode
      when setimeout is removed it scrolls and then keyboard opens because of which the scrolling
       doest happen perfectly */
      // setTimeout(() => {
      // if (deviceHeightLessThan640()) {
      //   /*
      //  scrolling down some extra px  so that when scrolled to element header is fixed the field is focused the
      //  field is visible and keyboard doesnt overlap
      // */
      //   scrollInContentWrap(loginComponentOffsetTop + 16);
      // } else {
      //   // for devices with height greater than 640 there is no issue of overlap so scroll to component works
      //   scrollInContentWrap(loginComponentOffsetTop + 16);
      // }
      // }, 350);
    } catch (error) {
      log({ eventType: EVENT.MOBILE_NUMBER_FOCUS, error });
    }
  };

  focusOnOTPInput = () => {
    try {
      log({ eventType: EVENT.OTP_FOCUS });
      setTimeout(() => {
        !isIphoneDevice() && this.otpRef && this.otpRef.focus();
      }, 100);
      /*
        scrolling down 280px  (calculated by elements height above the input) so that when the field is focused the
        field is visible  and keyboard doesnt overlap
       */
      scrollInContentWrap(285);
    } catch (error) {
      log({ eventType: EVENT.OTP_FOCUS_ERROR, error });
    }
  };

  handleComponentClick = () => {
    this.props.onSelectChange(this.props.option);
    this.props.updatePcfAmount(null);
    this.props.applyPromoForPayMode();
    setTimeout(() => {
      if (!this.state.showOtpInput) {
        /* focus on mobile number input t */
        // this.focusOnMobileInput();
        this.props.onBtnTextChange(this.label.btnSendOtpText);
      } else {
        /* focus on otp input */
        // this.focusOnOTPInput();
        this.props.onBtnTextChange(this.label.btnVerifyOtpText);
      }
    }, 0);
    this.setState({ sendOtpApiMsg: false, invalidMobileNumber: false, showOtpInputErr: false });
    this.props.onPayChange(true);
  };

  submit = () => {
    if (!this.state.showOtpInput) {
      this.sendOtp(false);
    } else {
      this.verifyOtp(this.state.otp);
    }
  };

  restrictInput = ev => {
    let digit = String.fromCharCode(ev.which);
    if (ev.key !== undefined) {
      digit = ev.key;
    }
    // any other character than digit
    if (!/^\d+$/.test(digit)) {
      if (ev.which !== 8 && ev.which !== 9 && ev.which !== 37 && ev.which !== 39) {
        ev.preventDefault();
      }
    }
    this.setState({ showMobileInputErr: false });
  };

  handleFocusInMobile = () => {
    this.setState({ monileNumberFocus: true, otpFocus: false });
  };

  handleFocusInOtp = () => {
    this.setState({ monileNumberFocus: false, otpFocus: true });
  };

  keyUpMobile = (e, inputLength) => {
    e.currentTarget.value = e.currentTarget.value.replace(this.numberRegex, '');
    if (e.currentTarget.value.length > inputLength) {
      e.currentTarget.value = e.currentTarget.value.substring(0, e.currentTarget.value.length - 1);
    }
    this.mobileRef.value = e.currentTarget.value;
    this.setState({
      invalidMobileNumber: false,
      sendOtpApiMsg: false,
      mobileNumber: this.mobileRef.value
    });
  };

  keyUpOtp = (e, inputLength) => {
    e.currentTarget.value = e.currentTarget.value.replace(this.numberRegex, '');
    if (e.currentTarget.value.length > inputLength) {
      e.currentTarget.value = e.currentTarget.value.substring(0, e.currentTarget.value.length - 1);
    }
    this.setState({ otp: e.currentTarget.value, showOtpInputErr: false });
  };

  hideOtpSentMessage = () => {
    this.props.onOtpSentChange(false);
  };

  sendOtp = (isResend = true) => {
    if (isResend) {
      log({ eventType: EVENT.REQUEST_ANOTHER_OTP });
    }
    const mobileNumber = this.mobileRef.value;
    if (Number.isNaN(mobileNumber) || mobileNumber.toString().length !== 10) {
      this.setState({ invalidMobileNumber: true, showOtpInput: false });
    } else {
      this.props.onPayChange(false);
      this.props.cache
        .getData(CACHE.API)
        .sendOtp(mobileNumber)
        .then(res => {
          this.props.onPayChange(true);
          res = res.body;
          this.setState({ showMobileInputErr: false, invalidMobileNumber: false });
          if (res && getKey(res, 'resultInfo.resultStatus')) {
            if (res.resultInfo.resultStatus === 'S' || res.resultInfo.resultStatus === 'SUCCESS') {
              this.setState({ showOtpInput: true });
              this.props.onOtpSentChange(true);
              this.props.onBtnTextChange(this.label.btnVerifyOtpText);
              this.interval = setTimeout(this.hideOtpSentMessage.bind(this), 5000);
              /* focus on otp input */
              // this.focusOnOTPInput();
            } else if (getKey(res, 'resultInfo.resultMsg')) {
              this.setState({
                sendOtpApiMsg: res.resultInfo.resultMsg,
                showOtpInput: false,
                showMobileInputErr: true
              });
            }
          }
        })
        .catch(() => {
          this.props.onPayChange(true);
        });
    }
  };

  handlePastedInput = e => {
    const clipboard = e.clipboardData || window.clipboardData;
    let output = '';
    if (clipboard) {
      output = (clipboard.getData && clipboard.getData('text')) || '';
    }
    let otp = output.replace(/\D/g, '');
    otp = otp.substring(0, 6);
    e.target.value = otp;
    this.setState({ otp });
    e.preventDefault();
  };

  verifyOtp = otp => {
    if (Number.isNaN(otp) || otp.toString().length !== 6) {
      log({ eventType: EVENT.CLIENT_VALIDATION_INVALID_OTP, value: otp });
      this.setState({
        showOtpInputErr: true,
        VerifyOtpMsg: this.error.invalidOtpLength
      });
    } else {
      log({ eventType: EVENT.MANUAL_LOGIN });
      this.props.onPayChange(false);
      const _rememberMe = this.state.rememberMe;
      this.props.cache
        .getData(CACHE.API)
        .verifyOtp(otp, _rememberMe)
        .then(res => {
          this.props.onPayChange(true);
          res = res.body;
          if (res && getKey(res, 'resultInfo')) {
            if (res.resultInfo.resultStatus === 'S' || res.resultInfo.resultStatus === 'SUCCESS') {
              log({ eventType: EVENT.LOGIN_SUCCESSFUL });
              /* adding try catch so that if there is error in processing logging  data txn flow is not affected  */
              try {
                const cashierData = JSON.parse(JSON.stringify(getKey(res, 'cashierData', null)));
                /* Adding Logic for using saved Paymode in local Storage when user is logged in */
                this.props.cache.setData(
                  CONSTANT.IS_LOGGED_IN,
                  getKey(cashierData, 'loginInfo.userLoggedIn')
                );
                if (
                  this.props.cache.getData(CONSTANT.IS_LOGGED_IN) &&
                  this.props.cache.getData(CONSTANT.IS_LOCAL_STORAGE_ALLOWED)
                ) {
                  this.props.cache.setData(
                    CONSTANT.MOBILE_NO,
                    getKey(cashierData.userDetails, 'mobile')
                  );
                  processLocalStorage(this.props.cache);
                }
                const cashierDataForLogging = removeDataForLogging(cashierData);
                log({ eventType: EVENT.LOGIN_FPO_RESPONSE, cashierData: cashierDataForLogging });
              } catch (error) {
                log({ eventType: EVENT.LOGIN_FPO_RESPONSE_ERROR, error });
              }
              this.setState({ isOtpValid: true, showOtpInputErr: false });
              if (this.props.checkoutElementPayMode) {
                globaleStore.setState({ [GLOBAL_STORE.FPO_UPDATED_RESPONSE]: cloneObject(res) });
              } else {
                const { onSelectChange, onLoginDataChange, onBtnTextChange } = this.props;
                updateOnNewFPO(
                  res,
                  this.props.cache,
                  this.props.checkoutElementPayMode,
                  this.props.subscription,
                  {
                    onSelectChange,
                    onLoginDataChange,
                    onBtnTextChange
                  }
                );
                // scrollInContentWrap(60);
              }
              this.clearOtp();
            } else {
              const errorMsg = getKey(res, 'resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
              this.setState({
                isOtpValid: false,
                showOtpInputErr: true,
                VerifyOtpMsg: errorMsg
              });
            }
          }
        })
        .catch(err => {
          this.props.onPayChange(true);
          const errorMsg = getKey(err, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
          this.setState({
            showOtpInputErr: true,
            VerifyOtpMsg: errorMsg
          });
        });
    }
  };

  rememberMe = () => {
    this.setState(prevState => {
      log({ eventType: EVENT.REMEMBER_ME, value: !prevState.rememberMe });
      return { rememberMe: !prevState.rememberMe };
    });
  };

  componentWillReceiveProps(previousProps) {
    const selected = getKey(this.props, 'selected', null);

    if (
      selected &&
      equalsIgnoreCase(selected.type, PAYMODE.LOGIN) &&
      previousProps.selected !== this.props.selected
    ) {
      this.setInitialState(false);
    }
  }

  changeNumber = () => {
    log({ eventType: EVENT.CHANGE_MOBILE_NUMBER });
    this.setState({ showOtpInput: false });
    // this.focusOnMobileInput();
    this.props.onBtnTextChange(this.label.btnSendOtpText);
    this.hideOtpSentMessage(); // hide send otp text when change is tapped and if msg is still visible
    clearInterval(this.interval); // clear the setTimeoutinterval for hiding the sent message timeout
    this.clearOtp(); // clear the previously entered OTP
  };

  clearOtp = () => {
    if (this.otpRef) {
      this.otpRef.value = '';
    }
  };

  render(
    { instanceKey, selected, loginInfo, option, isActive, isPromoAvailable },
    {
      showOtpInput,
      sendOtpApiMsg,
      invalidMobileNumber,
      showMobileInputErr,
      showOtpInputErr,
      VerifyOtpMsg,
      rememberMe,
      showRememberStrip,
      pwpEnabled
    }
  ) {
    return (
      <div class={`ptm-pay-method ptm-w100-ib`} id="checkout-login">
        <div class={`ptm-radio-wrap`} onClick={() => this.handleComponentClick()}>
          <label class="ptm-lbl">
            <input
              type="radio"
              name={`verify${instanceKey}`}
              checked={isActive}
              className={`ptm-margin0`}
            />
            <span class="ptm-checkmark" />
            <div class={`ptm-pay-method-cont`}>
              <p class={`ptm-paymode-name`}>
                <img
                  className={`ptm-wallet-logo ptm-pos-r ptm-left `}
                  src={`${staticPath()}/assets/images/logo-paytm.svg`}
                  alt="paytm"
                />
                Account
              </p>
              <p className="ptm-small-txt">{this.label.labelMessage}</p>
            </div>
          </label>
        </div>
        {loginInfo && selected && selected.id === option.id && (
          <div className={`ptm-pl-35`}>
            <div className={` ptm-inner-input-wrap ptm-pos-r ${showOtpInput ? 'ptm-hidden' : ''}`}>
              <input
                className={`ptm-pos-r ptm-margin0 ptm-pb-input ${
                  showMobileInputErr ? 'err' : ''
                } ptm-input-common `}
                id="mobile_input"
                type="tel"
                maxLength="10"
                ref={r => (this.mobileRef = r)}
                onKeyDown={e => this.restrictInput(e, 10)}
                onKeyUp={e => this.keyUpMobile(e, 10)}
                onFocusIn={() => this.handleFocusInMobile()}
              />
              <p
                className={`ptm-body-color ptm-placeholder-txt ptm-pos-a ${
                  this.mobileRef && this.mobileRef.value ? 'ptm-has-value' : ''
                }`}
              >
                Mobile Number
              </p>
              {isPromoAvailable && pwpEnabled && (
                <p className={`ptm-small-txt ptm-pwp-bo-warn`}>{getLocale('offers.pwpPreLogin')}</p>
              )}
              {invalidMobileNumber && (
                <p className="ptm-small-txt ptm-msg-red">{this.error.invalidMobileInput}</p>
              )}
              {sendOtpApiMsg && (
                <p className={`ptm-small-txt ptm-msg-red ptm-session-exp`}>{sendOtpApiMsg}</p>
              )}
              {showRememberStrip && !showOtpInput && (
                <label className="ptm-container ptm-mt-16">
                  <input
                    id="storeCard"
                    type="checkbox"
                    className="ptm-margin0"
                    checked={rememberMe}
                    onClick={() => this.rememberMe()}
                  />
                  <span className="ptm-check" />
                  {this.label.rememberMe}
                </label>
              )}
            </div>
            {/* enter otp screen */}
            <div className={`'otp-wrap' ${!showOtpInput ? 'ptm-hidden' : ''} ptm-otp-input-wrap`}>
              <div className={`ptm-otp-heading`}>
                <span className={`ptm-otp-txt ptm-body-color`}>
                  {this.label.otpSentNumberMessage}
                </span>
                <p className={`ptm-mo-number ptm-body-color`}>
                  {this.state.mobileNumber}
                  <span
                    className={`ptm-primary ptm-right ptm-change-number`}
                    onClick={this.changeNumber}
                  >
                    Change Number
                  </span>
                </p>
              </div>
              <p className={`ptm-otp ptm-body-color ptm-global-border`}>OTP</p>
              <input
                type="tel"
                id="ptm-otp-input"
                maxlength="6"
                autofocus
                ref={r => (this.otpRef = r)}
                className={`ptm-margin0 ptm-input-common ptm-enter-otp ${
                  showOtpInputErr ? 'err' : ''
                }`}
                onKeyDown={e => this.restrictInput(e, 6)}
                onKeyUp={e => this.keyUpOtp(e, 6)}
                onFocusIn={() => this.handleFocusInOtp()}
                onPaste={e => {
                  this.handlePastedInput(e);
                }}
              />
              {showOtpInputErr && <p className={`ptm-small-txt ptm-msg-red`}>{VerifyOtpMsg}</p>}
              <p className={`ptm-resend ptm-body-color`}>
                {this.label.otpNotreceived}
                <span className={`ptm-primary ptm-resend-otp`} onClick={() => this.sendOtp()}>
                  {this.label.requestOtp}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(
  'selected,loginInfo, cache, instanceKey, checkoutElementPayMode, subscription',
  onChange
)(LoginComponent);



// WEBPACK FOOTER //
// ./components/LoginComponent/loginComponent.js